import api from "@/services/api";
import type { GroupResponse } from "../types/groups.types";

export const groupsService = {
	getAll: () => api.get<GroupResponse[]>("/api/Group").then((r) => r.data),

	create: (name: string) =>
		api.post<GroupResponse>("/api/Group", { name }).then((r) => r.data),
};
